<div class="header-elements mub-header-elements nd_header-block">
  <div class="d-flex align-items-center">
    <img
      src="../../../../assets/icons/menu.svg"
      width="25px"
      height="auto"
      class="me-2 module-screen-icon"
      (click)="clickToggle()"
      alt="menu"
    />

    <span
      class="d-flex justify-content-start align-items-end"
      routerLink="/dashboard"
    >
      <img
        src="./assets/icons/logo_task.svg"
        class="TaskOPad-icon logo-filter-cls left"
        alt="TaskOPadLogo"
        draggable="false"
      />
      <img
        src="./assets/icons/logo_tick.svg"
        class="TaskOPad-icon"
        alt="TaskOPadLogo middle"
        draggable="false"
      />
      <img
        src="./assets/icons/logo_pad.svg"
        class="TaskOPad-icon logo-filter-cls right"
        alt="TaskOPadLogo"
        draggable="false"
      />
    </span>
  </div>
  <div class="right-align" >
    <ul class="list-unstyled d-flex align-items-center mb-0">
        <li routerLink="/management/subscription"
        class="ms-3 subscription-reminder"
        *ngIf="showSubscriptionReminder"
        [ngClass]="{ 'subscription-reminder--expired': subscriptionExpired }"
      >
        <div
          class="subscription-reminder__dot"
          [ngClass]="{
            'subscription-reminder__dot--expired': subscriptionExpired
          }"
        ></div>
        <div class="subscription-reminder__content">
          <span class="subscription-reminder__expires">
            Expires on <strong>{{ subscriptionExpiryLabel }}</strong>
          </span>
          <span
            class="subscription-reminder__count"
            [ngClass]="{
              'subscription-reminder__count--expired': subscriptionExpired
            }"
          >
            {{ subscriptionCountdownLabel }}
          </span>
        </div>
      </li>
      <li class="ms-3">
        <div class="main-toggle">
          <label for="theme" class="theme">
            <span class="theme__toggle-wrap">
              <input
                id="theme"
                class="theme__toggle"
                type="checkbox"
                role="switch"
                name="theme"
                [checked]="activeTheme"
                (click)="toggle()"
              />
              <span class="theme__icon">
                <span class="theme__icon-part"></span>
                <span class="theme__icon-part"></span>
                <span class="theme__icon-part"></span>
                <span class="theme__icon-part"></span>
                <span class="theme__icon-part"></span>
                <span class="theme__icon-part"></span>
                <span class="theme__icon-part"></span>
                <span class="theme__icon-part"></span>
                <span class="theme__icon-part"></span>
              </span>
            </span>
          </label>
        </div>
      </li>

    

      <li class="ms-3" *ngIf="showAnnouncement">
        <a href="">
          <img
            class="accouncement-icon-cls module-screen-icon"
            src="assets/icons/announcement.svg"
            alt="icon"
            draggable="false"
            (click)="openAnnouncement()"
          />
        </a>
      </li>
      <!-- Temporarily hidden for production testing.
      <li class="ms-3 bell-icons referral-icon-wrapper">
        <a
          (click)="redirectToReferralManagement()"
          class="referral-icon-btn"
          matTooltip="Referral"
          matTooltipPosition="below"
        >
          <img
            class="module-screen-icon"
            src="assets/icons/network.png"
            alt="referral icon"
            draggable="false"
          />
        </a>
      </li>
      -->
      <li class="ms-3 bell-icons">
        <a *ngIf="unreadNotificationCount == 0">
          <img
            class="module-screen-icon"
            src="assets/icons/bell.svg"
            alt="icon"
            draggable="false"
            (click)="redirectToNotificationList()"
          />
        </a>
        <a *ngIf="unreadNotificationCount > 0" (click)="isShowNotificationList = true">
          <img
            class="module-screen-icon"
            src="assets/icons/bell.svg"
            alt="icon"
            draggable="false"
            [matMenuTriggerFor]="notification"
          />
          <div
            class="unread-notification-count"
            *ngIf="
              unreadNotificationCount - 1 != 0 && unreadNotificationCount > 99
            "
          >
            <span>99+</span>
          </div>
          <div
            class="unread-notification-count"
            *ngIf="
              unreadNotificationCount - 1 != 0 && unreadNotificationCount <= 99
            "
          >
            {{ unreadNotificationCount }}
          </div>
          <div
            class="unread-notification-count"
            *ngIf="unreadNotificationCount - 1 == 0"
          >
            {{ unreadNotificationCount }}
          </div>
        </a>
        <mat-menu
          #notification
          xPosition="before"
          class="custom-dropdown-menu custom-dropdown-menu-ctm new-common-notification-cls-add"
        >
          <app-notification-preview
            *ngIf="isShowNotificationList"
          ></app-notification-preview>
        </mat-menu>
      </li>
      <li class="ms-3">
        <button
          mat-icon-button
          [matMenuTriggerFor]="menu"
          class="profile-dropdown d-flex"
          data-tour="header-profile-menu"
        >
          <img
            [src]="userImgPath"
            *ngIf="isValidImagePath(userImgPath)"
            class="user-img"
            alt="assignee profile"
            draggable="false"
          />
          <div
            *ngIf="shouldShowImageFallback(userImgPath)"
            class="user-short-name mr-0"
            [ngStyle]="{ 'background-color': '#DC3535' }"
          >
            {{ utils.forShortName(user) }}
          </div>
          <div class="ms-2 user-info">
            <div class="user-name text-capitalize">{{ user }}</div>
            <div class="user-id" *ngIf="userDetail?.userId">
              T-{{ userDetail.userId }}
            </div>
          </div>
          <span class="ms-2 user-name">
            <img
              src="assets/icons/downfilledarrow.svg"
              alt="icons"
              draggable="false"
              class="module-screen-icon-white"
            />
          </span>
        </button>
        <mat-menu #menu="matMenu" xPosition="before" class="custom-dropdown-menu">
          <ng-container *ngFor="let submenu of headerNav[0]; let i = index">
            <a [href]="submenu.route" class="submenu-elements">
              <button
                mat-menu-item
                *ngIf="submenu.name !== 'HELP' && submenu.name !== 'Logout'"
                [attr.data-tour]="
                  submenu.name === 'ORGANIZATION_MANAGEMENT'
                    ? 'header-organization-management'
                    : null
                "
              >
                {{ submenu.name | translate }}
              </button>
            </a>
            <button
              mat-menu-item
              routerLink="{{ submenu.route }}"
              *ngIf="submenu.name == 'Logout'"
              (click)="accountLogout()"
            >
              {{ submenu.name | translate }}
            </button>

            <button
              mat-menu-item
              mat-button
              mat-flat-button
              (click)="openGuideModal()"
              *ngIf="submenu.name == 'HELP'"
            >
              {{ submenu.name | translate }}
            </button>
          </ng-container>
        </mat-menu>
      </li>
    </ul>
  </div>
</div>
